import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CategoryService } from 'app/core/category/category.service';
import { SizeService } from 'app/core/size/size.service';
import { InitialData } from './size.types';

@Injectable({
    providedIn: 'root'
})
export class SizeDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _sizeService: SizeService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._sizeService.getSizes()
        .pipe(
            map((sizes) => ({
                sizes
            })
            ),
            catchError(err => {
                console.log(err);
                
                this._sizeService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                return of(new DefaultResponse().sizes);
            })
        );
        
    }

}
class DefaultResponse implements InitialData {
    sizes: any = [];
}